/**
 * Global Constants Configuration
 * Centralized location for all hardcoded values to avoid duplication
 */

export const CONTACT_INFO = {
  email: "contact@zsnexatech.com",
  phone: "+91 9978627178",
  phoneRaw: "919978627178", // For WhatsApp API (without +)
  whatsappUrl: "https://wa.me/919978627178",
};

export const SOCIAL_LINKS = {
  linkedin: "https://www.linkedin.com/company/zs-nexatech/",
  twitter: "https://twitter.com/zsnexatech",
  facebook: "https://facebook.com/zsnexatech",
  instagram: "https://www.instagram.com/zs_nexatech/",
};

export const WEBSITE_URL = "https://www.zsnexatech.com";

export const CALENDLY_CONFIG = {
  defaultUrl: "https://calendly.com/contact-zsnexatech/30min",
  getUrl: () => import.meta.env.VITE_CALENDLY_URL || "https://calendly.com/contact-zsnexatech/30min",
};

export const SEO_DEFAULTS = {
  siteName: "ZS NEXATECH",
  description: "Elite Product Engineering. From concept to deployment, we build secure, scalable, and conversion-focused digital platforms.",
};
